import { useEffect, useState, FC, ReactNode } from "react";
import popupStyles from "../templates/template-popup.module.css";
import { ProductCardFlexible } from "@sainsburys-tech/fable";
import { GridItem } from "@sainsburys-tech/grid";
import { useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
interface CustomPopupProps {
  title: string;
  tempid: string;
  CardPrint: any[];
  show: boolean;
  onClose: (value: boolean) => void;
  children: ReactNode;
}

const CustomPopup: FC<CustomPopupProps> = (props) => {
  const [show, setShow] = useState<boolean>(false);
  const pdfRef = useRef<HTMLDivElement>(null);
  const closeHandler = (e: React.MouseEvent<HTMLSpanElement>) => {
    setShow(false);
    props.onClose(false);
  };

  useEffect(() => {
    setShow(props.show);
  }, [props.show]);

  const downloadPDF = (): void => {
    const input = pdfRef.current;
    if (input) {
      html2canvas(input).then((canvas: HTMLCanvasElement) => {
        const imgData: string = canvas.toDataURL("image/png");
        const doc: jsPDF = new jsPDF("p", "mm", "a6", true);

        const pdfWidth: number = doc.internal.pageSize.getWidth();
        const pdfHeight: number = doc.internal.pageSize.getHeight();
        const imgWidth: number = canvas.width;
        const imgHeight: number = canvas.height;
        const ratio: number = Math.min(
          pdfWidth / imgWidth,
          pdfHeight / imgHeight
        );
        const imgX: number = (pdfWidth - imgWidth * ratio) / 2;
        const imgY: number = 7;

        doc.addImage(
          imgData,
          "PNG",
          imgX,
          imgY,
          imgWidth * ratio,
          imgHeight * ratio
        );
        doc.save("TemplatePrint.pdf");
      });
    }
  };
  return (
    <div
      style={{
        visibility: show ? "visible" : "hidden",
        opacity: show ? "1" : "0"
      }}
      className={popupStyles.overlay}
    >
      <div className={popupStyles.popup}>
        <div style={{ margin: "1% 3% 3% 2%" }} className="py-4">
          {props.CardPrint?.filter((item) =>
            props.tempid
              ? item.Id === props.tempid
              : item.Id.includes(props.tempid)
          ).map((value) => (
            <GridItem
              key={value.Id}
              style={{ width: "280px", padding: "1%", marginTop: "8%" }}
              className="demo-item demo-item__alt"
            >
              <ProductCardFlexible>
                <div key={value.Id} ref={pdfRef}>
                  <ProductCardFlexible.Image onDoubleClick={downloadPDF}>
                    <div className="ds-max-w-full">
                      <img
                        alt={value.Configuration?.Image}
                        style={{
                          border: "1px solid #0084F0",
                          padding: "5%"
                        }}
                        src={`data:image/jpeg;base64,${value.Configuration?.Image}`}
                        className="ds-w-full ds-max-w-full ds-object-cover ds-object-center"
                      />
                    </div>
                  </ProductCardFlexible.Image>
                  <b className={popupStyles.wordWrap}>
                    Template ID: {value.Identity.SBTemplateId}
                  </b>
                </div>
                <ProductCardFlexible.Body>
                  <ProductCardFlexible.Body.Section></ProductCardFlexible.Body.Section>
                  <ProductCardFlexible.Body.Section></ProductCardFlexible.Body.Section>
                </ProductCardFlexible.Body>
                <ProductCardFlexible.Footer></ProductCardFlexible.Footer>
              </ProductCardFlexible>
            </GridItem>
          ))}
        </div>
        <span className={popupStyles.close} onClick={closeHandler}>
          &times;
        </span>
        <div className={popupStyles.content}>{props.children}</div>
      </div>
    </div>
  );
};

export default CustomPopup;
